import api from './api';

export const getCoupons = async (params = {}) => {
  const response = await api.get('/coupons', { params });
  return response.data;
};

export const getCouponById = async (id) => {
  const response = await api.get(`/coupons/${id}`);
  return response.data;
};

export const createCoupon = async (data) => {
  const response = await api.post('/coupons', data);
  return response.data;
};

export const updateCoupon = async (id, data) => {
  const response = await api.put(`/coupons/${id}`, data);
  return response.data;
};

export const deleteCoupon = async (id) => {
  const response = await api.delete(`/coupons/${id}`);
  return response.data;
};
